<template>
  <div class="kontrollerComp">
    <nav-local-comp :all="'Кресла'" :id="id" :toAll="toAll"/>
    <tabs-comp :moduleName="moduleName"/>
    <kontroller-status-one-comp v-if="tabs.info.active"/>
    <kontroller-programs-crud-comp v-if="tabs.programs.active"/>
    <kontroller-point-one-comp v-if="tabs.point.active"/>
    <kontroller-dealer-one-comp v-if="role == 'admin' && tabs.dealer.active"/>
    <kontrollers-log-comp v-if="tabs.log.active" :params="{ idMysql: id }"/>
    <orders-comp v-if="tabs.orders.active" :params="{ kontrollerIdMysql: id }"/>
  </div>
</template>

<script>
export default {
  name: 'kontrollerComp',
  props: {},
  data: function () {
    return {
      moduleName: 'kontrollers',
      required: null
    }
  },
  created: function () {
    this.$store.dispatch(`${this.moduleName}/getOne`, { required: this.required })
  },
  components: {},
  computed: {
    id: function () {
      return this.$store.getters[`${this.moduleName}/getId`]
    },
    tabs: function () {
      return this.$store.getters[`${this.moduleName}/getTabs`]
    },
    role: function () {
      return localStorage.getItem('role')
    }
  },
  methods: {
    toAll () {
      this.$store.dispatch(`${this.moduleName}/toAll`)
    }
  }
}
</script>

<style scoped lang="scss">
</style>
